import { emailCheck } from '../regex';

export const isEmail = str => emailCheck.test(String(str).toLowerCase());
